// layout
export { default as CardIcon } from "./layout/card.svg";
export { default as CartIcon } from "./layout/cart.svg";
export { default as HeartIcon } from "./layout/heart.svg";
export { default as Heart2Icon } from "./layout/heart2.svg";
export { default as MailIcon } from "./layout/mail.svg";
export { default as PhoneIcon } from "./layout/phone.svg";
export { default as UserIcon } from "./layout/user.svg";
export { default as LeftArrow } from "./layout/left-arrow.svg";
export { default as TriangleRight } from "./layout/triangle-right.svg";
export { default as DeleteIcon  } from "./layout/delete.svg";
export { default as HelpCircle  } from "./layout/help-circle.svg";
export { default as SearchIcon  } from "./layout/search.svg";
export { default as YoutubeIcon  } from "./layout/youtube.svg";
export { default as FacebookIcon  } from "./layout/facebook.svg";
export { default as InstagramIcon  } from "./layout/instagram.svg";
export { default as StarsIcon  } from "./layout/stars.svg";

// Logos
export { default as Logo } from "./logos/logo-1.svg";
export { default as Logo2 } from "./logos/logo-2.svg";
export { default as Logo3 } from "./logos/logo-3.svg";
export { default as Logo4 } from "./logos/logo-4.svg";
export { default as Logo5 } from "./logos/logo-5.svg";
export { default as Logo6 } from "./logos/logo-6.svg";
export { default as Logo7 } from "./logos/logo-7.svg";

// Home
export { default as VerifiedIcon } from "./home/verified.svg";
export { default as YoutubeLogo } from "./home/youtube-logo.svg";
export { default as YoutubeLogo1 } from "./home/youtube-logo1.svg";
export { default as MedalIcon } from "./home/medal.svg";
export { default as CheckBox } from "./home/check-box.svg";
export { default as YoutubePlay } from "./home/youtube-play.svg";

// contact
export { default as InboxIcon } from "./contact/inbox.svg";
export { default as Phone1Icon } from "./contact/phone.svg";
export { default as PinLocationIcon } from "./contact/pin-location.svg";

// cart
export { default as EmptyCartIcon } from "./cart/empty-cart.svg";
export { default as PencilIcon } from "./cart/pencil.svg";
export { default as TrashIcon } from "./cart/trash.svg";




export { default as PaymentIcon } from "./shipping/payment.svg";